import type { ProductCarouselItem } from '@/components/Carousels/ProductCarousel';
import type { CarouselProductMapperProps } from '@/services/mappers/common/carouselProductMapper';

export const mapCarouselProductToCarouselItem = ({
  code,
  sku,
  brand,
  subBrand,
  name,
  url,
  images,
  price,
  tags,
  hasGift,
  isSponsored,
}: CarouselProductMapperProps): ProductCarouselItem => ({
  productCode: code,
  code: sku,
  title: brand?.name,
  subtitle: {
    name: subBrand?.name,
    url: subBrand?.relativeUrl,
  },
  description: name,
  url,
  images: {
    mainImage: images.mainImage,
    alt: images.alt,
  },
  price,
  tags,
  hasGift,
  isSponsored,
});
